// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-tds-master',
//   templateUrl: './tds-master.component.html',
//   styleUrls: ['./tds-master.component.scss']
// })
// export class TdsMasterComponent {

// }
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmationService, Message } from 'primeng/api';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
 @Component({
 selector: 'app-tds-master',
 templateUrl: './tds-master.component.html',
 styleUrls: ['./tds-master.component.scss']
})
export class TdsMasterComponent implements OnInit {
  date: any;
  submitButton: string = 'Submit'
  manufactureTable: any = [];
  myDate: any;
  loading: boolean = false;
  msgs: Message[] = [];

  constructor(private _apiService: ApiServiceService, private _utility: AppUtility , private confirmService : ConfirmationService) { }

  ngOnInit(): void {
    this.getAllTableData();
  }

  breadcrumb = [
    {
      title: 'TDS Master',
      subTitle: 'Dashboard'
    }
  ]

  valuesteamform = new FormGroup({
  tdstypeName: new FormControl('', [Validators.required]),
  })

  valuesteamformSubmit(manufacture: FormGroupDirective) {
    console.log(this.valuesteamform.value);
    if (this.valuesteamform.valid) {
      this._utility.loader(true);
      let object = this.valuesteamform.value;
      if (this.submitButton == 'Submit') {
        this._apiService.addtdsmster(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success')
            window.scroll(0, 0)
            this.valuesteamform.reset();
            // ;          
            Object.keys(this.valuesteamform.controls).forEach(key => {
              this.valuesteamform.controls[key].setErrors(null)
            });
            manufacture.resetForm();
            this.getAllTableData();

          }
          else {
            this._apiService.showMessage(res.message, 'success');
          }

        })
      }
      else {
        object['tdsTypeId'] = this.editItemId;
        console.log(object);
        this._apiService.edittdsmster(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success');
            this.valuesteamform.reset();
            Object.keys(this.valuesteamform.controls).forEach(key => {
              this.valuesteamform.controls[key].setErrors(null)
            });
            manufacture.resetForm();
            this.submitButton = 'Submit'
            this.getAllTableData();
          }

          else {
            this._apiService.showMessage(res.message, 'error');
          }
        })
      }
    }
  }

  editItemId: any;
    EditItem(customer: any) {
      console.log(customer);
      debugger
     this.valuesteamform.patchValue({
      tdstypeName: customer.tdsTypeName, // map customer key to form control
    });
      console.log(this.valuesteamform.controls.tdstypeName,"checked");
      
        this.submitButton = 'Update'
        this.editItemId = customer.tdsTypeId;   
        console.log(this.editItemId,"checked");
          
      }

  getAllTableData() {
    this._utility.loader(true);
    this._apiService.gettdsmster()
      .then((res: any) => {
        this._utility.loader(false);
        if (res.success == true) {
          this.manufactureTable = res.returnValue;
        }
        else {
          this.manufactureTable = [];
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.manufactureTable = [];
      })
  }

  confirm1(costBreakupId: any) {
    this.confirmService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Delete Other Category Record',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteItem(costBreakupId);
        this.msgs = [{ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' }];
      },
      reject: () => {
        this.msgs = [{ severity: 'info', summary: 'Rejected', detail: 'You have rejected' }];
      }
    });
  }

  deleteItem(itemId: any) {
    this._utility.loader(true);
    this._apiService.deletetdsmster(itemId)
    .then((res: any) => {
      this._utility.loader(false);
      console.log(res);      
      if (res.success == true) {
        this._apiService.showMessage(res.message, 'success');
        this.getAllTableData();
      }

      else {
        window.scroll(0, 0);
        this._apiService.showMessage(res.message, 'error');
        this.getAllTableData();
      }

    })
  }
   keyPress(event: KeyboardEvent) {
  const allowedPattern = /^[0-9+\-.,%]*$/;

  const input = event.target as HTMLInputElement;
  const inputValue = input.value;
  const char = String.fromCharCode(event.charCode);

  const proposedValue = inputValue + char;

  if (!allowedPattern.test(proposedValue)) {
    event.preventDefault();
  }
}

}
